var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 12c0 5.515-4.486 10-10 10S2 17.515 2 12C2 6.486 6.486 2 12 2s10 4.486 10 10z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.22 10.557a.747.747 0 01-.218.53l-3.47 3.486a.751.751 0 01-1.063 0l-3.472-3.487a.749.749 0 111.063-1.058L12 12.982l2.94-2.954a.75.75 0 011.28.53z",
    fill: "#ED1B2E"
  })));
}

export default SvgArrowDownCircle;